module.exports = __webpack_public_path__ + "static/media/logo.d1fcaed0.png";